import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from '@cotera/client/v0/components/ui/alert';
import { Button } from '@cotera/client/v0/components/ui/button';

/**
 * Asks before a sharing change that takes access away, in place, with the
 * change and a way back.
 */
export const ShareConfirmAlert: React.FC<{
  title: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  children: React.ReactNode;
}> = ({ title, confirmLabel, onConfirm, onCancel, children }) => (
  <Alert variant="warning">
    <AlertTriangle className="h-4 w-4" />
    <AlertTitle>{title}</AlertTitle>
    <AlertDescription className="whitespace-normal">
      {children}
      <span className="mt-2 flex gap-2">
        <Button size="sm" variant="destructive" onClick={onConfirm}>
          {confirmLabel}
        </Button>
        <Button size="sm" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </span>
    </AlertDescription>
  </Alert>
);
